import { telaSobDemanda } from '../../nucleo/paginas/TelaSobDemanda';
import type { ModuloWeb } from '../../nucleo/modulos';
import { dicionario } from './i18n';

const carregar0 = () => import('./MutualForce');

const MutualForcePage = telaSobDemanda(carregar0, 'MutualForcePage');

export const modulo: ModuloWeb = {
  slug: 'mutualforce',
  menu: 'mutualforce',
  dicionario,
  abas: [
    { rotulo: 'abas.hoje', caminho: 'hoje', elemento: <MutualForcePage key="hoje" aba="hoje"/>, ordem: 1 },
    { rotulo: 'abas.relacionamentos', caminho: 'relacionamentos', elemento: <MutualForcePage key="relacionamentos" aba="relacionamentos"/>, ordem: 2 },
    { rotulo: 'abas.oportunidades', caminho: 'oportunidades', elemento: <MutualForcePage key="oportunidades" aba="oportunidades"/>, ordem: 3 },
    { rotulo: 'abas.agentes', caminho: 'agentes', elemento: <MutualForcePage key="agentes" aba="agentes"/>, ordem: 4 },
    { rotulo: 'abas.historico', caminho: 'historico', elemento: <MutualForcePage key="historico" aba="historico"/>, ordem: 5 },
  ],
};
